export const theme = {
  primary: "#1DC071",
  secondary: "#A4D96C",
  grayDark: "#292D32",
  grayLight: "#E7ECF3",
  tertiary: "#3A1097",
  accent: "#00D1ED",
  grayF3: "#F3EDFF",
  gray6B: "#6B6B6B",
  gray23: "#232323",
  gray4b: "#4B5264",
  grayf1: "#F1F1F3",
  gray80: "#808191",
  black: "#171725",
};

export const postStatus = {
  APPROVED: 1,
  PENDING: 2,
  REJECTED: 3,
};

export const categoryStatus = {
  APPROVED: 1,
  UNAPPROVED: 2,
};

export const userStatus = {
  ACTIVE: 1,
  PENDING: 2,
  BAN: 3,
};

export const userRole = {
  ADMIN: 1,
  MOD: 2,
  USER: 3,
};
